import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { sp } from '@/theme/mui';
import { Title } from '@/components/atoms/Title/Title';
import { Button } from '@/components/atoms/Button/Button';

export const DeleteAccount = ({}: DeleteAccountProps) => {
  return (
    <Stack
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        gap: sp[24],
        m: sp[24],
        mt: sp[96],
      }}
    >
      <Title>Delete account</Title>
      <Box sx={{ typography: 'bodyMd', color: '#666667', textAlign: 'center' }}>
        If you'd like to delete your account, feel free to get in touch with us
        at &nbsp;
        <Button
          variant='link'
          size='md'
          isInline
          ariaLabel='here'
          to={`mailto://${process.env.REACT_APP_SUPPORT_EMAIL}`}
        >
          {process.env.REACT_APP_SUPPORT_EMAIL}
        </Button>
        .<br /> Don't hesitate to reach out if you have any questions or
        concerns.
        <br /> We're here to help!
      </Box>
    </Stack>
  );
};

interface DeleteAccountProps {}

DeleteAccount.displayName = 'AccountDelete';

export default DeleteAccount;
